// extracted by mini-css-extract-plugin
export default {"switcher":"SideBarSwitcher_switcher__NptXq","toggle":"SideBarSwitcher_toggle__+1lsB","unchecked":"SideBarSwitcher_unchecked__ZJZl3","checked":"SideBarSwitcher_checked__gci51"};